document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-fabric-reveal-toggle]');
  if (!toggle) return;

  var root = toggle.closest('[data-fabric-reveal]');
  if (!root) return;

  var expanded = root.getAttribute('data-expanded') === 'true';
  var next = !expanded;

  root.setAttribute('data-expanded', next ? 'true' : 'false');
  toggle.setAttribute('aria-expanded', next ? 'true' : 'false');

  var labelMore = toggle.querySelector('[data-label-more]');
  var labelLess = toggle.querySelector('[data-label-less]');

  if (labelMore && labelLess) {
    labelMore.hidden = next;
    labelLess.hidden = !next;
  }
});